import { UserMailConfiguration, UserOffice } from "@/type/core/auth/auth.types";
import { MailConfiguration } from "@/type/core/dashboard/dashboard.types";

export class MailHelper {
  static getSenderLabelFromMailConfiguration = (
    mailConfiguration: UserMailConfiguration,
    selectedOffice?: UserOffice,
  ): string => {
    switch (mailConfiguration.senderEmailLabel) {
      case "jesignexpert":
        return "Jesignexpert.com";
      case "custom":
        return mailConfiguration.senderEmailLabelText;
      case "alias":
      default:
        const alias = selectedOffice?.alias;
        return alias?.startsWith("Cabinet")
          ? `${alias} - Jesignexpert`
          : `Cabinet ${alias} - Jesignexpert`;
    }
  };

  static fromUserMailConfigurationToMailConfiguration = (
    userMailConfiguration?: UserMailConfiguration,
    selectedOffice?: UserOffice,
  ): MailConfiguration | undefined => {
    if (!userMailConfiguration) {
      return undefined;
    }
    return {
      message: userMailConfiguration.message,
      sender: {
        type: userMailConfiguration.senderEmailLabel,
        value: this.getSenderLabelFromMailConfiguration(
          userMailConfiguration,
          selectedOffice,
        ),
      },
      signature: userMailConfiguration.signature,
      subject: userMailConfiguration.subject,
      isDefault: userMailConfiguration.isDefault,
    };
  };
}
